import { render, staticRenderFns } from "./FolderAccount.vue?vue&type=template&id=1ab56d73"
import script from "./FolderAccount.vue?vue&type=script&lang=js"
export * from "./FolderAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports